<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Relação de Endossos
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          N. COTAÇÃO
          <p>{{ formatarNumeroCotacao(infoEndosso.numeroCotacao) }}</p>
        </v-flex>
        <v-flex row wrap>
          N. PROPOSTA / APÓLICE
          <p>{{ infoEndosso.numeroApolice }}</p>
        </v-flex>
        <v-flex>
          DIAS DE VIGÊNCIA APÓLICE
          <p>{{ infoEndosso.diasVigencia }}</p>
        </v-flex>
        <v-flex
          >RAZÃO SOCIAL
          <p>{{ infoEndosso.razaoSocial }}</p>
        </v-flex>
        <v-flex>
          CNPJ
          <p>{{ infoEndosso.cnpj }}</p>
        </v-flex>

        <v-flex>
          {{ 'QTD. \u00CDTENS' }}
          <p>{{ infoEndosso.qtdItens }}</p>
        </v-flex>
        <br />
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>

    <v-container pa-5 class="background data-table">
      <v-card elevation="0">
        <v-card-title>
          <v-flex xs12 sm11 md6 lg4>
            <transition name="fade">
              <v-flex xs1 v-if="!filtro.pesquisa.opened">
                <v-btn
                  v-if="!filtro.pesquisa.opened"
                  @click="filtroFunctions().abrirFiltroPesquisa()"
                  color="primary"
                  round
                  outline
                  icon
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  v-model="filtro.pesquisa.conteudo"
                  prepend-icon="search"
                  @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                  @blur="filtroFunctions().fecharFiltroPesquisa()"
                  label="Busca"
                  autofocus
                  clearable
                ></v-text-field>
              </v-flex>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-btn
            v-if="!selected && idStatusCorretorReserva != 6 && idStatusCorretorReserva != 10"
            color="primary"
            round
            dark
            @click="dialog = true"
            >NOVO ENDOSSO</v-btn
          >
        </v-card-title>
      </v-card>
      <template>
        <div class="table-width">
          <v-data-table
            :headers="headers"
            :items="endossoList"
            hide-actions
            :rows-per-page-items="[10]"
            item-key="item"
            class="elevation-0"
          >
            <template v-slot:items="props">
              <td
                v-for="([texto, atributos], index) in colunas(props.item)"
                :key="index"
                v-bind="atributos"
                :class="[' themeGrey--text click', ...(atributos.class || [])]"
                @click="handleAbrirEndosso(props.item)"
              >
                {{ texto }}
              </td>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
              v-model="paginacao.page"
              :length="paginacao.totalPages"
              circle
            ></v-pagination>
          </div>
        </div>
      </template>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
    <v-layout pt-5>
      <v-flex>
        <v-btn color="primary" @click="voltar" flat> Voltar </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialog" max-width="600px">
          <ModalEndossos
            v-if="dialog"
            :dialog="dialog"
            :idApolice="idApolice"
            :tipoEndossoList="listaTipoEndossos"
            @fecharDialogoEndosso="dialog = false"
            :idStatusCorretorReserva="idStatusCorretorReserva"
            :corretorReserva="true"
            @abrirEndossoCancelamento="
              (dialog = false), (dialogEndossoCancelamento = true)
            "
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogHistorico" max-width="520px">
          <ModalHistorico
            v-if="dialogHistorico"
            :dialog="dialogHistorico"
            @fecharDialogHistorico="dialogHistorico = false"
            :uuidRevisao="this.uuidRevisaoHistorico"
            :idRascunho="this.idRascunhoHistorico"
            :numeroProposta="this.numeroPropostaHistorico"
            :numeroRevisao="this.numeroRevisaoHistorico"
            :idStatus="this.statusPropostaHistorico"
            :endosso="true"
          />
        </v-dialog>
      </v-layout>
    </template>

  </v-container>
</template>
<script>
import axios from 'axios';
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalEndossos  from '../frota/ModalEndosso.vue';
import ModalHistorico from "../frota/ModalHistorico.vue";
import tipoEndossoEnum from "@/helpers/tipo-endosso-enum.js";


export default {
  name: "GridEndossoCorretor",
  components: {
    ModalEndossos,
    ModalHistorico
  },
  data() {
    return {
      infoEndosso:{
        razaoSocial: null,
        cnpj: null,
        numeroCotacao: null,
        diasVigencia: null,
        qtdItens: null,
        numeroProposta: null
      },
      listaTipoEndossos: [],
      quantItens:null,
      dialogHistorico: false,
      diasVigencia: null,
      idStatusCorretorReserva: null,
      idApolice: null,
      filtrarErros: false,
      dialogEndossoCancelamento: false,
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogAvaliando: false,
      dialogConfirmacao: false,
      dialogErros: false,
      numeroPropostaHistorico: null,
      idRascunhoHistorico: null,
      selected: null,
      regras: {
        notNull: [(v) => !!v || "Você não pode deixar este campo em branco"],
      },
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: "",
        },
      },
      resultados: {
        totalPremio: null,
      },
      paginacao: {
        page: 1,
        size: 10,
        totalPages: 0,
      },
      endossoList: [],
      endosso: {},
      uuidRevisaoHistorico: null,
      statusPropostaHistorico: null,
      dialogHistorico: false,
      numeroRevisaoHistorico: null,
      numeroRevisaoHistoricoErro: null,

      headers: [
        { text: "N. COTAÇÃO ENDOSSO", value: "numeroCotacao" },
        { text: "N. DO ENDOSSO ESSOR", value: "numeroEndosso" },
        { text: "N. PROPOSTA / ENDOSSO", value: "numeroProposta" },
        {
          text: "STATUS DO ENDOSSO",
          value: "idStatusEndosso",
          style: "width: 100px",
        },
        { text: "TIPO DO ENDOSSO", value: "idTipoEndosso" },
        { text: "TIPO DE OPERAÇÃO", value: "idTipoOperacao" },
        { text: "QTD. \u00CDTENS (INCLUS. / EXCLUS.)", value: "itemExcInc" },
        { text: "DATA DA PROPOSTA", value: "dataProposta" },
        { text: "INÍCIO VIGÊNCIA ENDOSSO", value: "dataInicio" },
        { text: "FIM VIGÊNCIA ENDOSSO", value: "dataFim" },
      ],
    };
  },
  watch: {
    "paginacao.page"() {
      this.buscarEndossos();
    },
    "paginacao.size"() {
      this.buscarEndossos();
    },
    "filtro.status.selecionado": function (val) {
      this.filtroFunctions().aplicarFiltros();
    },
  },
  mounted() {
    this.$store.commit("formEndosso/limparTudo");
    this.idApolice = parseInt(this.$route.query.id);
    this.idStatusCorretorReserva = this.$route.query.idStatusCorretorReserva
      ? this.$route.query.idStatusCorretorReserva
      : null;
    this.retornarListagemEndossos();
    this.retornarInfoEndossos();
    this.buscarEndossos();

  },
  methods: {
    handleAbrirEndosso(item) {
      const abrirEndosso = [
        tipoEndossoEnum.tipoEndosso.COBRANCA,
        tipoEndossoEnum.tipoEndosso.SUBSTITUICAO,
        tipoEndossoEnum.tipoEndosso.EXCLUSAO
      ];
      if (abrirEndosso.includes(item.idTipoEndosso)) {
        this.abrirEndosso(item.numeroRevisao, item.idTipoEndosso, item.idRascunhoEndosso, item.idStatusEndosso);
      } else if(item.idTipoEndosso === tipoEndossoEnum.tipoEndosso.RESTITUICAO){
        this.dialogRestituicao = true;
      }
    },

    abrirEndosso(numeroRevisao, idTipoEndosso, idRascunhoEndosso, idStatusEndosso) {
      this.$router.push(
        `/corretor/InfoEndosso?id=${
          this.idApolice
        }&idStatusEndosso=${
          idStatusEndosso
        }&idTipoEndosso=${idTipoEndosso}${
          this.idStatusCorretorReserva ? `&idStatusCorretorReserva=${this.idStatusCorretorReserva}` : ''
        }${
          numeroRevisao ? `&numeroRevisao=${numeroRevisao}` : ''
        }${
          idRascunhoEndosso ? `&idRascunhoEndosso=${idRascunhoEndosso}` : ''
        }&corretorParceiro=true`
      );
    },

    abrirdialogHistorico(idRevisao, idRascunhoEndosso, numeroProposta, statusProposta, numeroRevisao ) {
       if( idRevisao != null ) {
        this.uuidRevisaoHistorico = idRevisao;
      } else if( idRascunhoEndosso != null ){
        this.idRascunhoHistorico = idRascunhoEndosso;
      }

      if( numeroProposta ) {
        this.numeroPropostaHistorico = numeroProposta.toString();
      } else {
        this.numeroPropostaHistorico = "0";
      }

      this.numeroRevisaoHistorico = numeroRevisao;
      this.statusPropostaHistorico = statusProposta;
      this.dialogHistorico = true;
    },
     abrirdialogHistoricoErro(numeroRevisao) {
      this.dialogErros = true;
      this.numeroRevisaoHistoricoErro = numeroRevisao;

    },
    fecharDialogHistoricoErro(){
      this.dialogErros = false;
    },
    fecharDialogHistorico(){
      this.dialogHistorico = false;
    },
    colunas(item) {
      return [
        [this.formatarNumeroCotacao(item.numeroRevisao), { class: "pa-4" }],
        [item.numeroEndosso || '-', { class: "pa-4" }],
        [item.codigoEndosso, { class: "pa-4" }],
        [this.formatStatusEndosso(item.idStatusEndosso), { class: "pa-4" }],
        [this.formatTipoEndosso(item.idTipoEndosso), {}],
        [this.formatTipoOperacao(item.idTipoEndosso), {}],
        [item.itemExcInc, {}],
        [this.formatarData(item.dataProposta), {}],
        [this.formatarData(item.dataInicio), {}],
        [this.formatarData(item.dataFim), {}],
      ];
    },
    retornarInfoEndossos() {
      this.$store.commit("startLoading");
      axios.get(`${process.env.URL_APOLICEMS}/v1/buscarInfoEndosso/${this.idApolice}`, {
        headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          }
      }).then((response) => {
          this.infoEndosso = response.data;
      }).catch(error => {
        if (error.response && error.response.data) {
            this.errorMessage =
              error.response.data.erros || error.response.data.message;
          } else {
            this.errorMessage = error.response.data.message;
          }
      })
      this.$store.commit("endLoading");
    },
    retornarListagemEndossos() {
      this.$store.commit("startLoading");
      axios.get(`${process.env.URL_ENDOSSOMS}/v1/retornaTipoEndossos/${this.idApolice}?corretorReserva=true`, {
        headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          }
      }).then(response => {
        return response.data;
      }).then(data => {
        this.listaTipoEndossos = data;
      }).catch(error => {
        if (error.response && error.response.data) {
            this.errorMessage =
              error.response.data.erros || error.response.data.message;
          } else {
            this.errorMessage = error.response.data.message;
          }
      })
      this.$store.commit("endLoading");

    },
    formatarNumeroCotacao(item) {
      if(item !=null) {
        const numero = `000000${item}`;
        return numero.slice(numero.length - 6);
      }
    },
    somaNumeros(numeros) {
      let soma = 0;
      for(let i = 0 ; i < numeros.length ; i++) {
        soma += numeros[i].itemExcInc
      } return soma
    },

    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatarData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
    },
    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },

    formatStatusEndosso(status) {
      if (status == 1) return "EM AN\u00C1LISE";
      if (status == 2) return "EMITIDA";
      if (status == 3) return "AG. ENDOSSO";
      if (status == 4) return "ENDOSSO APROVADO";
      if (status == 5) return "ENDOSSO REPROVADO";
      if (status == 8) return "PENDENTE";
      if (status == 9) return "RECUSADO";
    },
    formatTipoEndosso(tipo) {
      if (tipo == 1) return "COBRANÇA";
      if (tipo == 3) return "SEM MOVIMENTAÇÃO"
      if (tipo == 5) return "SUBSTITUIÇÃO"

    },

    formatTipoOperacao(tipo){
      if (tipo == 1) return "COBRANÇA";
      if (tipo == 3) return "EXCLUSÃO"
      if (tipo == 5) return "SUBSTITUIÇÃO"

    },
    filtroFunctions: function () {
      const self = this;
      return {
        abrirFiltroPesquisa: function () {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function () {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        },
      };
    },

    voltar: function () {
      this.$router.push(`/GridSolicitacaoCotacao`)
    },


    buscarEndossos() {
      this.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/listarEndossos/`+ this.idApolice + `/?page=${
            this.paginacao.page - 1
          }&size=${this.paginacao.size}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => {
          this.endossoList = response.data.content.filter(item => item.idTipoEndosso !== tipoEndossoEnum.tipoEndosso.ALTERACAO);
          this.paginacao.totalPages = response.data.totalPages;
          if(response.data.content.length > 0){
            this.endosso = response.data.content[0];
            this.contarData();
            this.quantItens = this.somaNumeros(this.endossoList)
          }

          this.filtroFunctions().aplicarFiltros();
          this.$store.commit("endLoading");
        })
        .catch((err) => {
          this.$store.commit("endLoading");
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/GridEndossoCorretor.vue